import React from 'react';
import { ArrowUpRight, Loader2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { useStripeConnection } from '@/hooks/useStripeConnection';

interface EmptyStateProps {
  title: string;
  description: string;
  actionLabel: string;
  actionLink?: string;
  icon?: React.ReactNode;
  identifier?: boolean; // <== used to trigger Stripe connect mode
}

const EmptyState: React.FC<EmptyStateProps> = ({
  title,
  description,
  actionLabel,
  icon,
  identifier = false,
}) => {
  const {
    isConnected,
    isConnecting,
    handleConnect,
  } = useStripeConnection();

  return (
    <div className="flex flex-col items-center justify-center text-center p-10 bg-card rounded-lg border border-dashed border-border">
{icon && !identifier && (
  <div className="mb-4 text-muted-foreground">{icon}</div>
)}      <h3 className="text-xl font-semibold mb-2 text-foreground">{title}</h3>
      <p className="text-muted-foreground max-w-md mb-6">{description}</p>
    </div>
  );
};

export default EmptyState;
